import { useState } from "react";
import { toast } from "sonner";
import { Lightbulb, Send } from "lucide-react";
import { api, errorMessage } from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";

const blank = { club: "", why: "", name: "", email: "", links: "" };

export const SuggestClubDialog = ({ show }) => {
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState(blank);
  const [busy, setBusy] = useState(false);
  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/join", { kind: "club", name: form.name, email: form.email, show_name: form.club, subject: show.name, pitch: form.why, links: form.links });
      toast.success(`Thanks — ${form.club} is on the list!`);
      setForm(blank); setOpen(false);
    } catch (err) { toast.error(errorMessage(err)); }
    finally { setBusy(false); }
  };

  return (
    <>
      <Button type="button" onClick={() => setOpen(true)} className="rounded-full bg-amber-400 text-[#070F1E] font-bold hover:bg-amber-300 px-5" data-testid="suggest-club-button"><Lightbulb size={16} className="mr-2" /> Suggest a Club</Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="sm:max-w-lg bg-[#0B1A33] border-white/10 text-white" data-testid="suggest-club-dialog">
          <DialogHeader>
            <DialogTitle className="font-display text-2xl font-extrabold">Suggest a club</DialogTitle>
            <DialogDescription className="text-slate-400">Know a club with a story worth telling? Tell us which one and why — it might be the next episode of {show.name}.</DialogDescription>
          </DialogHeader>
          <form onSubmit={submit} className="space-y-4">
            <div><Label>Club *</Label><Input required maxLength={200} value={form.club} onChange={(e) => set("club", e.target.value)} placeholder="e.g. Union Berlin" className="mt-1.5 bg-white/5 border-white/10" data-testid="suggest-club-name" /></div>
            <div><Label>Why this club? *</Label><Textarea required minLength={10} maxLength={2000} rows={4} value={form.why} onChange={(e) => set("why", e.target.value)} placeholder="What makes them special — the fans, the history, the ground, a moment…" className="mt-1.5 bg-white/5 border-white/10" data-testid="suggest-club-why" /></div>
            <div className="grid sm:grid-cols-2 gap-4">
              <div><Label>Your name *</Label><Input required minLength={2} maxLength={120} value={form.name} onChange={(e) => set("name", e.target.value)} className="mt-1.5 bg-white/5 border-white/10" data-testid="suggest-club-your-name" /></div>
              <div><Label>Email *</Label><Input required type="email" maxLength={200} value={form.email} onChange={(e) => set("email", e.target.value)} className="mt-1.5 bg-white/5 border-white/10" data-testid="suggest-club-email" /></div>
            </div>
            <div><Label>Links <span className="text-slate-500">(optional)</span></Label><Input maxLength={1000} value={form.links} onChange={(e) => set("links", e.target.value)} placeholder="Club site, article, video…" className="mt-1.5 bg-white/5 border-white/10" data-testid="suggest-club-links" /></div>
            <div className="flex justify-end gap-2 pt-1">
              <Button type="button" variant="ghost" onClick={() => setOpen(false)} className="rounded-full hover:bg-white/10">Cancel</Button>
              <Button type="submit" disabled={busy} className="rounded-full bg-amber-400 text-[#070F1E] font-bold hover:bg-amber-300 px-5" data-testid="suggest-club-submit"><Send size={15} className="mr-2" /> {busy ? "Sending…" : "Send suggestion"}</Button>
            </div>
          </form>
        </DialogContent>
      </Dialog>
    </>
  );
};
